import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function CustomNavbar() {

  return (
    <>
      <Navbar bg="dark" data-bs-theme="dark">
        <Container>
          <Navbar.Brand href="/"><img
          src={require('../../resources/images/dinvicard-logo.PNG')}
          loading="lazy"
          style={{ width: "30px", height: "30px", borderRadius:"50%"} }
          alt=""
        /></Navbar.Brand>
          <Navbar.Brand href="/">DInviCard</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="create">Create</Nav.Link>
            {/* <Nav.Link href="signup">Register</Nav.Link> */}
            <Nav.Link href="login">Login</Nav.Link>
            <Nav.Link href="about">About</Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <br />
      
    </>
  );
}

export default CustomNavbar;